import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useI18n } from "../context/I18nContext";

export default function Partners() {
  const { t } = useI18n();
  const types = t("partners.types") || [];
  const [f, setF] = useState({ company_name:"", contact_person:"", role:"", email:"", phone:"", country:"", partnership_type: types[0] || "", budget:"", message:"" });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setF(s => ({ ...s, [k]: v }));
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/partner", f);
      toast.success(t("partners.thanks"));
      setF({ company_name:"", contact_person:"", role:"", email:"", phone:"", country:"", partnership_type: types[0] || "", budget:"", message:"" });
    } catch { toast.error(t("common.errGeneric")); }
    finally { setLoading(false); }
  };
  return (
    <div data-testid="partners-page">
      <section className="hero-gradient py-24">
        <div className="max-w-6xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">{t("pages.partners.tag")}</div>
          <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">{t("pages.partners.t1")}<br/><span className="italic text-warm-orange">{t("pages.partners.t2")}</span></h1>
        </div>
      </section>
      <section className="py-16 bg-ivory">
        <div className="max-w-6xl mx-auto px-5 lg:px-10 grid md:grid-cols-4 gap-3 mb-10">
          {types.map((ty,i)=>(
            <div key={ty} className="p-4 rounded-xl bg-pearl text-deep-blue text-sm font-semibold" data-testid={`ptype-${i}`}>{ty}</div>
          ))}
        </div>
        <form onSubmit={submit} className="max-w-4xl mx-auto px-5 lg:px-10 grid md:grid-cols-2 gap-4">
          <input required placeholder={t("partners.companyName")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none md:col-span-2" value={f.company_name} onChange={e=>set("company_name",e.target.value)} data-testid="p-company"/>
          <input required placeholder={t("partners.contactPerson")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.contact_person} onChange={e=>set("contact_person",e.target.value)} data-testid="p-contact"/>
          <input placeholder={t("partners.role")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.role} onChange={e=>set("role",e.target.value)} data-testid="p-role"/>
          <input required type="email" placeholder={t("partners.emailPro")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.email} onChange={e=>set("email",e.target.value)} data-testid="p-email"/>
          <input placeholder={t("common.phone")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.phone} onChange={e=>set("phone",e.target.value)} data-testid="p-phone"/>
          <input placeholder={t("common.country")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.country} onChange={e=>set("country",e.target.value)} data-testid="p-country"/>
          <select className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none bg-white" value={f.partnership_type} onChange={e=>set("partnership_type",e.target.value)} data-testid="p-type">
            {types.map(ty=><option key={ty}>{ty}</option>)}
          </select>
          <input placeholder={t("partners.budget")} className="p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none md:col-span-2" value={f.budget} onChange={e=>set("budget",e.target.value)} data-testid="p-budget"/>
          <textarea rows={4} placeholder={t("common.message")} className="md:col-span-2 p-4 rounded-xl border-2 border-black/5 focus:border-gold outline-none" value={f.message} onChange={e=>set("message",e.target.value)} data-testid="p-message"/>
          <button disabled={loading} className="btn-gold md:col-span-2 py-4 rounded-full font-semibold" data-testid="p-submit">{loading?t("common.sending"):t("partners.submit")}</button>
        </form>
      </section>
    </div>
  );
}
